import type { IconGlyph } from '../icon';

/**
 * Tractie `sun` glyph (medium, 24×24).
 *
 * Source: `@tractie/icons` v1.2.1 — `dist/jsx/m/sun.jsx`.
 */
export const iconSun: IconGlyph = {
  name: 'sun',
  path: 'M12 18c-.28 0-.5.22-.5.5v3c0 .28.22.5.5.5s.5-.22.5-.5v-3c0-.28-.22-.5-.5-.5m-4.95-1.76-2.12 2.12c-.2.2-.2.51 0 .71s.51.2.71 0l2.12-2.12c.2-.2.19-.51 0-.71-.2-.2-.51-.2-.71 0m9.9 0c-.2-.19-.51-.2-.71 0s-.19.51 0 .71l2.12 2.12c.2.19.51.2.71 0s.2-.51 0-.71zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4m0 7c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3m-6-3c0-.28-.22-.5-.5-.5h-3c-.28 0-.5.22-.5.5s.22.5.5.5h3c.28 0 .5-.22.5-.5m15.5-.5h-3c-.28 0-.5.22-.5.5s.22.5.5.5h3c.28 0 .5-.22.5-.5s-.22-.5-.5-.5M5.64 4.93c-.2-.2-.51-.2-.71 0s-.19.51 0 .71l2.12 2.12c.2.19.51.2.71 0s.2-.51 0-.71zm11.31 2.83 2.12-2.12c.2-.2.2-.51 0-.71s-.51-.2-.71 0l-2.12 2.12c-.2.2-.19.51 0 .71.2.2.51.2.71 0M12 6c.28 0 .5-.22.5-.5v-3c0-.28-.22-.5-.5-.5s-.5.22-.5.5v3c0 .28.22.5.5.5',
};
